export const emojiMenus = [
  {
    id: 6,
    topId: 3,
    code: 'DASHBOARD',
    name: '대시보드',
    nameEn: 'Dashboard',
    nameKo: '대시보드',
    route: '/dashboard',
    ordinal: 1,
    visible: true,
    emoji: '🥁',
  },
  {
    id: 7,
    topId: 4,
    code: 'CONNECTOR',
    name: '수집 설정',
    nameEn: 'Connector',
    nameKo: '수집 설정',
    route: '/connector',
    ordinal: 1,
    visible: false,
    emoji: '🎰',
  },
  {
    id: 8,
    topId: 4,
    code: 'PARSER',
    name: '원본 로그 파서',
    nameEn: 'Parser',
    nameKo: '원본 로그 파서',
    route: '/parser',
    ordinal: 2,
    visible: false,
    emoji: '🎪',
  },
  {
    id: 46,
    topId: 4,
    code: 'NORMALIZER',
    name: '정규화 파서',
    nameEn: 'Normalizer',
    nameKo: '정규화 파서',
    route: '/normalizer',
    ordinal: 3,
    visible: true,
    emoji: '🚌',
  },
  {
    id: 9,
    topId: 4,
    code: 'SCHEMA',
    name: '정규화',
    nameEn: 'Schema',
    nameKo: '정규화',
    route: '/schema',
    ordinal: 4,
    visible: true,
    emoji: '🚗',
  },
  {
    id: 10,
    topId: 4,
    code: 'CONNECTOR_MODEL',
    name: '수집 모델',
    nameEn: 'Connector Model',
    nameKo: '수집 모델',
    route: '/connector-model',
    ordinal: 5,
    visible: true,
    emoji: '🚠',
  },
  {
    id: 11,
    topId: 4,
    code: 'EXTRACTOR_MODEL',
    name: '추출 모델',
    nameEn: 'Extractor Model',
    nameKo: '추출 모델',
    route: '/extractor-model',
    ordinal: 6,
    visible: false,
    emoji: '🚖',
  },
  {
    id: 44,
    topId: 5,
    code: 'EVENT_SUMMARY',
    name: '탐지 현황',
    nameEn: 'Event Summary',
    nameKo: '탐지 현황',
    route: '/event-summary',
    ordinal: 0,
    visible: false,
    emoji: '🥁',
  },
  {
    id: 12,
    topId: 5,
    code: 'EVENT',
    name: '이벤트',
    nameEn: 'Event',
    nameKo: '이벤트',
    route: '/event',
    ordinal: 1,
    visible: true,
    emoji: '🎰',
  },
  {
    id: 13,
    topId: 5,
    code: 'LOG',
    name: '로그',
    nameEn: 'Log',
    nameKo: '로그',
    route: '/log',
    ordinal: 2,
    visible: false,
    emoji: '🎪',
  },
  {
    id: 14,
    topId: 5,
    code: 'PIVOT',
    name: '피벗',
    nameEn: 'Pivot',
    nameKo: '피벗',
    route: '/pivot',
    ordinal: 3,
    visible: false,
    emoji: '🚌',
  },
  {
    id: 15,
    topId: 5,
    code: 'DATASET',
    name: '데이터셋',
    nameEn: 'Dataset',
    nameKo: '데이터셋',
    route: '/dataset',
    ordinal: 4,
    visible: true,
    emoji: '🚗',
  },
  {
    id: 16,
    topId: 5,
    code: 'QUERY',
    name: '쿼리',
    nameEn: 'Query',
    nameKo: '쿼리',
    route: '/query',
    ordinal: 5,
    visible: true,
    emoji: '🚠',
  },
  {
    id: 43,
    topId: 5,
    code: 'PRIVATE_IP',
    name: '내부 IP',
    nameEn: 'Private IP',
    nameKo: '내부 IP',
    route: '/private-ip',
    ordinal: 7,
    visible: true,
    emoji: '🚖',
  },
  {
    id: 48,
    topId: 5,
    code: 'PROCEDURE',
    name: '프로시저',
    nameEn: 'Procedure',
    nameKo: '프로시저',
    route: '/procedure',
    ordinal: 8,
    visible: true,
    emoji: '🥁',
  },
  {
    id: 55,
    topId: 5,
    code: 'REPORT',
    name: '보고서',
    nameEn: 'Report',
    nameKo: '보고서',
    route: '/report',
    ordinal: 9,
    visible: true,
    emoji: '🎰',
  },
  {
    id: 18,
    topId: 6,
    code: 'TICKET',
    name: '티켓',
    nameEn: 'Ticket',
    nameKo: '티켓',
    route: '/tickets',
    ordinal: 1,
    visible: true,
    emoji: '🎪',
  },
  {
    id: 51,
    topId: 6,
    code: 'REPOSITORY',
    name: '티켓 분류',
    nameEn: 'Repository',
    nameKo: '티켓 분류',
    route: '/tickets/repositories',
    ordinal: 2,
    visible: true,
    emoji: '🚌',
  },
  {
    id: 19,
    topId: 6,
    code: 'EXPLANATION',
    name: '소명',
    nameEn: 'Explanation',
    nameKo: '소명',
    route: '/explanation',
    ordinal: 3,
    visible: true,
    emoji: '🚗',
  },
  {
    id: 20,
    topId: 6,
    code: 'EXPLANATION_REVIEW',
    name: '소명 리뷰',
    nameEn: 'Explanation Review',
    nameKo: '소명 리뷰',
    route: '/explanation-review',
    ordinal: 4,
    visible: true,
    emoji: '🚠',
  },
  {
    id: 21,
    topId: 6,
    code: 'EXPLANATION_SUBMIT',
    name: '소명 결제',
    nameEn: 'Explanation Submit',
    nameKo: '소명 결제',
    route: '/explanation-submit',
    ordinal: 5,
    visible: true,
    emoji: '🚖',
  },
  {
    id: 22,
    topId: 7,
    code: 'STREAM_RULE',
    name: '실시간 탐지',
    nameEn: 'Realtime Detection',
    nameKo: '실시간 탐지',
    route: '/stream-rule',
    ordinal: 1,
    visible: true,
    emoji: '🥁',
  },
  {
    id: 23,
    topId: 7,
    code: 'BATCH_RULE',
    name: '배치 탐지',
    nameEn: 'Batch Detection',
    nameKo: '배치 탐지',
    route: '/batch-rule',
    ordinal: 2,
    visible: true,
    emoji: '🎰',
  },
  {
    id: 24,
    topId: 7,
    code: 'ML_MODEL',
    name: '머신러닝 모델',
    nameEn: 'Machine Learning Model',
    nameKo: '머신러닝 모델',
    route: '/ml-model',
    ordinal: 3,
    visible: true,
    emoji: '🎪',
  },
  {
    id: 25,
    topId: 7,
    code: 'TI_FEED',
    name: '위협 인텔리전스',
    nameEn: 'Threat Intelligence',
    nameKo: '위협 인텔리전스',
    route: '/threat-intelligence',
    ordinal: 4,
    visible: true,
    emoji: '🚌',
  },
  {
    id: 26,
    topId: 7,
    code: 'BEHAVIOR_PROFILE',
    name: '행위 프로파일',
    nameEn: 'Behavior Profile',
    nameKo: '행위 프로파일',
    route: '/behavior-profile',
    ordinal: 5,
    visible: true,
    emoji: '🚗',
  },
  {
    id: 27,
    topId: 7,
    code: 'ML_INPUT',
    name: '학습 데이터셋',
    nameEn: 'Machine Learning Dataset',
    nameKo: '학습 데이터셋',
    route: '/ml-input',
    ordinal: 6,
    visible: true,
    emoji: '🚠',
  },
  {
    id: 28,
    topId: 7,
    code: 'IP_BLACKLIST',
    name: 'IP 블랙리스트',
    nameEn: 'IP Blacklist',
    nameKo: 'IP 블랙리스트',
    route: '/ip-blacklist',
    ordinal: 7,
    visible: true,
    emoji: '🚖',
  },
  {
    id: 29,
    topId: 7,
    code: 'SUBNET_GROUP',
    name: '네트워크 대역',
    nameEn: 'Subnet Group',
    nameKo: '네트워크 대역',
    route: '/subnet-group',
    ordinal: 8,
    visible: true,
    emoji: '🥁',
  },
  {
    id: 30,
    topId: 7,
    code: 'PORT_GROUP',
    name: '포트 그룹',
    nameEn: 'Port Group',
    nameKo: '포트 그룹',
    route: '/port-group',
    ordinal: 9,
    visible: true,
    emoji: '🎰',
  },
  {
    id: 31,
    topId: 7,
    code: 'PATTERN_GROUP',
    name: '패턴 그룹',
    nameEn: 'Pattern Group',
    nameKo: '패턴 그룹',
    route: '/pattern-group',
    ordinal: 10,
    visible: true,
    emoji: '🎪',
  },
  {
    id: 50,
    topId: 7,
    code: 'ALARM_GROUP',
    name: '알람 그룹',
    nameEn: 'Alarm Group',
    nameKo: '알람 그룹',
    route: '/alarm-group',
    ordinal: 11,
    visible: true,
    emoji: '🚌',
  },
  {
    id: 32,
    topId: 8,
    code: 'ACCOUNT',
    name: '계정',
    nameEn: 'Account',
    nameKo: '계정',
    route: '/users',
    ordinal: 1,
    visible: true,
    emoji: '🚗',
  },
  {
    id: 49,
    topId: 8,
    code: 'USER_GROUP',
    name: '계정 그룹',
    nameEn: 'User Group',
    nameKo: '계정 그룹',
    route: '/user-group',
    ordinal: 2,
    visible: true,
    emoji: '🚠',
  },
  {
    id: 33,
    topId: 8,
    code: 'COMPANY',
    name: '회사',
    nameEn: 'Company',
    nameKo: '회사',
    route: '/companies',
    ordinal: 3,
    visible: true,
    emoji: '🚖',
  },
  {
    id: 34,
    topId: 8,
    code: 'EMPLOYEE',
    name: '임직원',
    nameEn: 'Employee',
    nameKo: '임직원',
    route: '/employees',
    ordinal: 4,
    visible: true,
    emoji: '🥁',
  },
  {
    id: 35,
    topId: 9,
    code: 'CLUSTER',
    name: '노드 설정',
    nameEn: 'Cluster',
    nameKo: '노드 설정',
    route: '/node-config',
    ordinal: 1,
    visible: true,
    emoji: '🎰',
  },
  {
    id: 36,
    topId: 9,
    code: 'SENTRY',
    name: '센트리 관리',
    nameEn: 'Sentry',
    nameKo: '센트리 관리',
    route: '/sentry',
    ordinal: 2,
    visible: true,
    emoji: '🎪',
  },
  {
    id: 37,
    topId: 9,
    code: 'TABLE',
    name: '테이블 관리',
    nameEn: 'Table',
    nameKo: '테이블 관리',
    route: '/table',
    ordinal: 3,
    visible: true,
    emoji: '🚌',
  },
  {
    id: 38,
    topId: 9,
    code: 'CRYPTO',
    name: '암호화',
    nameEn: 'Crypto',
    nameKo: '암호화',
    route: '/crypto-profile',
    ordinal: 4,
    visible: true,
    emoji: '🚗',
  },
  {
    id: 39,
    topId: 9,
    code: 'LICENSE',
    name: '라이센스',
    nameEn: 'License',
    nameKo: '라이센스',
    route: '/license',
    ordinal: 5,
    visible: true,
    emoji: '🚠',
  },
  {
    id: 40,
    topId: 9,
    code: 'SMTP',
    name: '메일 서버',
    nameEn: 'Mail Server',
    nameKo: '메일 서버',
    route: '/smtp',
    ordinal: 6,
    visible: true,
    emoji: '🚖',
  },
  {
    id: 41,
    topId: 9,
    code: 'PUSH_TEMPLATE',
    name: '소명 템플릿',
    nameEn: 'Mail Template',
    nameKo: '소명 템플릿',
    route: '/explanation-template',
    ordinal: 7,
    visible: true,
    emoji: '🥁',
  },
  {
    id: 42,
    topId: 9,
    code: 'EXPLANATION_CATEGORY',
    name: '소명 분류',
    nameEn: 'Explanation Category',
    nameKo: '소명 분류',
    route: '/explanation-categories',
    ordinal: 8,
    visible: false,
    emoji: '🎰',
  },
  {
    id: 45,
    topId: 9,
    code: 'QUERY_MONITOR',
    name: '쿼리 모니터',
    nameEn: 'Query Monitor',
    nameKo: '쿼리 모니터',
    route: '/query-monitor',
    ordinal: 8,
    visible: true,
    emoji: '🎪',
  },
  {
    id: 47,
    topId: 9,
    code: 'AUDIT_LOG',
    name: '감사 로그',
    nameEn: 'Audit Log',
    nameKo: '감사 로그',
    route: '/audit-log',
    ordinal: 10,
    visible: true,
    emoji: '🚌',
  },
  {
    id: 56,
    topId: 9,
    code: 'CONNECT_PROFILE',
    name: '접속 프로파일',
    nameEn: 'Connect Profile',
    nameKo: '접속 프로파일',
    route: '/connect-profile',
    ordinal: 11,
    visible: true,
    emoji: '🚗',
  },
];
